module.exports = __webpack_public_path__ + "static/sport/register-1.7a0a596.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ldp/form/register-1.png
// module id = yLlx
// module chunks = 0